import { render, staticRenderFns } from "./YearPlanManagementBakup.vue?vue&type=template&id=17b0c267&scoped=true"
import script from "./YearPlanManagementBakup.vue?vue&type=script&lang=js"
export * from "./YearPlanManagementBakup.vue?vue&type=script&lang=js"
import style0 from "./YearPlanManagementBakup.vue?vue&type=style&index=0&id=17b0c267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0c267",
  null
  
)

export default component.exports